export const prepareLanguageForRequest = (lang: string) => {
  return lang.split('-')[0];
};
